import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import AppShell from "./AppShell";
import { GET, profile } from "../components/CustomComponent";

// Layout ของทุกหน้าในระบบ CMRU: ใช้โครงเดียวกับ AppShell แต่สลับ navbar เป็นชุดของ CMRU
// และกันคนที่ไม่มีสิทธิ์เข้าระบบ (พิมพ์ URL /cmru/... เข้ามาตรง ๆ) ให้เด้งกลับระบบหลัก
export default function CmruShell({ title, description, children }) {
  // โปรไฟล์ที่ cache ไว้บอกว่าเข้าได้ -> แสดงหน้าเลยไม่ต้องรอ
  // ถ้าไม่มีค่า (เช่น cache เก่าก่อนมีระบบ CMRU) ให้ถาม backend ซึ่งเป็นตัวตัดสินจริง
  const [allowed, setAllowed] = useState(profile?.systems?.cmru ? true : null);

  useEffect(() => {
    let isMounted = true;

    const verifyAccess = async () => {
      const result = await GET("v1/cmru/welcome", null, null, { silent: true });
      if (!isMounted) return;

      // network / server error ไม่นับว่าไม่มีสิทธิ์ คงสถานะเดิมไว้ (403 เท่านั้นที่เด้งออก)
      if (result?.status === true) setAllowed(true);
      else if (result?.status_code === 403) setAllowed(false);
      else setAllowed((current) => current ?? false);
    };

    verifyAccess();

    return () => {
      isMounted = false;
    };
  }, []);

  if (allowed === false) return <Navigate replace to="/welcome" />;

  return (
    <AppShell title={title} description={description} system="cmru">
      {allowed ? children : null}
    </AppShell>
  );
}
